function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m9.621 13.542.006.004a2.95 2.95 0 0 0 3.672-.403l.413-.412a.984.984 0 0 0 0-1.392l-1.74-1.738a.985.985 0 0 0-1.39 0 .983.983 0 0 1-1.392 0L6.407 6.818a.984.984 0 0 1 0-1.391.983.983 0 0 0 0-1.39L4.668 2.294a.985.985 0 0 0-1.391 0l-.413.413a2.95 2.95 0 0 0-.403 3.671l.004.007a26.6 26.6 0 0 0 7.156 7.156"
  }));
};
export default SvgPhone;